(function () {
    var $htmlBody = $("html, body");
    var headerHeight = 0;

    repositionCards();

    $(".accordion-xlg >.card >.card-header button").on("click", function (e) {
        var $element = $(this);

        if ($element.attr("aria-expanded") === "false") {
            setTimeout(function () {
                scrollToContent($element);
            }, 400);
        }
    });

    $(".accordion-sider.full button").on("click", function() {
        if($(this).attr("aria-expanded") === "true") {
            $(this).parent().toggleClass("open");
        } else {
            $(".accordion-sider.full .card-header").removeClass("open");
            
            $(this).parent().toggleClass("open");
        }
    });

    $(".accordion-sider.full .btn-close").on("click", function() {
        $(".accordion-sider.full .card-header").removeClass("open");
    })

    // stop bubble up js
    $(".append-download").on("click", function (e) {
        e.stopImmediatePropagation();
    })

    $(".fancybox").fancybox();

    function repositionCards() {
        $(".accordion-sider").each(function () {
            var sider = $(this);
            var introHeader = sider.parentsUntil(".accordion").find(".intro-header");
            var siderTop = sider.offset().top;
            var introPos = introHeader.offset().top + introHeader.outerHeight() + 30;
            
            if ($(window).width() > 767) {
                sider.css("top", introPos - siderTop)
            } else {
                sider.css("top", "")
            }
        });

    }

    function calcHeaderHeight() {
        if (!$(".header__title").is(":visible")) {
            headerHeight = $(".header").outerHeight(true);
        } else {
            headerHeight = $(".header__top").outerHeight(true) +
                $(".header__title").outerHeight(true);
        }
    }

    function scrollToContent($elem) {
        var id = $elem.parents(".card").attr("id");
        var buttonHeight = $elem.parents(".card").find(".card-header").height();

        calcHeaderHeight();

        var top = $("#" + id).offset().top;

        $htmlBody.animate({
            scrollTop: top - headerHeight + buttonHeight
        }, 700);
    }   


    $(window).resize(function () {
        if ($(window).width() > 767) {
            location.reload();
        } else {
            repositionCards();
        }

    })
})();